import "JS/helpers/customEventPolyfill";
import { mapGetters } from "vuex"
import FormValidationMixin from "JS/mixins/campaign/formValidation"

export default {
  mixins: [FormValidationMixin],
  computed: {
    ...mapGetters({
      actionCompleted: "navigation/actionCompleted",
      actionError: "forms/actionError",
      campaignRestrictionError: "navigation/campaignRestrictionsError",
      completedAllActions: "navigation/completedAllActions",
      currentAction: "navigation/activeAction",
      currentStep: "navigation/activeStep",
      legislatorError: "legislators/errorMessage",
      legislatorResults: "legislators/legislatorResults",
      validationResults: "forms/validationResults"
    })
  },
  watch: {
    actionCompleted(val) {
      const event = new CustomEvent("action", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    actionError(val) {
      const event = new CustomEvent("actionError", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    campaignRestrictionError(val) {
      const event = new CustomEvent("campaignRestrictionError", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    completedAllActions(val) {
      const event = new CustomEvent("completedAllActions", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    currentAction(val) {
      const event = new CustomEvent("actionChange", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    currentStep(val) {
      const event = new CustomEvent("stepChange", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    isFormValid(val) {
      const event = new CustomEvent("formValid", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    legislatorError(val) {
      const event = new CustomEvent("legislatorError", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    },
    legislatorResults(val) {
      const event = new CustomEvent("legislatorsFetched", {  bubbles: true, detail: val })
      document.dispatchEvent(event)
    }
  }
}
